import { b2bAddressesApi } from '../b2b/addresses';
import { b2cAddressesApi } from '../b2c/addresses';
import { B2B_ADDRESSES_PATH, B2C_ADDRESSES_PATH, ZIP_CODE_PATH, } from '../../constants/links';
import { apiB2B, apiB2C, apiBase } from '../axios-client';
import { mapAddressListToCommonModel } from '../../utils/mapping-addresses';
import { ERROR_CODES } from '../../constants/custom-errors';
import { ADDRESSES_PAGE_SIZE } from '../../constants/general';
var handleAddressesResponse = function (data) {
    var _a;
    var addresses = (_a = data.addresses) === null || _a === void 0 ? void 0 : _a.address;
    var paginationInfo = data.paginationInfo;
    var totalNumberOfAddresses = paginationInfo === null || paginationInfo === void 0 ? void 0 : paginationInfo.totalNumberOfRecords;
    if (Array.isArray(addresses) && addresses.length > 0) {
        return mapAddressListToCommonModel(addresses, paginationInfo);
    }
    if (!Number(totalNumberOfAddresses)) {
        throw new Error(ERROR_CODES.NO_SAVED_ADR_CODE);
    }
    throw new Error(ERROR_CODES.NO_FOUND_ADR_CODE);
};
export var addressesApi = {
    getAddresses: function (isB2B, _a) {
        var page = _a.page, sortBy = _a.sortBy, ascendingOrder = _a.ascendingOrder;
        if (isB2B) {
            return apiB2B
                .get(B2B_ADDRESSES_PATH, {
                params: {
                    ps: ADDRESSES_PAGE_SIZE,
                    pn: page || 1,
                    sb: sortBy || 'lastedited',
                    asc: ascendingOrder || false,
                },
            })
                .then(function (_a) {
                var data = _a.data;
                return handleAddressesResponse(data);
            });
        }
        return apiB2C
            .get(B2C_ADDRESSES_PATH, {
            params: {
                pageSize: ADDRESSES_PAGE_SIZE,
                pageNumber: page || 1,
            },
        })
            .then(function (_a) {
            var data = _a.data;
            return handleAddressesResponse(data);
        });
    },
    deleteAddress: function (isB2B, _a) {
        var addrIdentifier = _a.addrIdentifier, userId = _a.userId, lastModifiedDate = _a.lastModifiedDate;
        if (isB2B) {
            return b2bAddressesApi.deleteAddress({ addrIdentifier: addrIdentifier, userId: userId });
        }
        return b2cAddressesApi.deleteAddress({ addrIdentifier: addrIdentifier, lastModifiedDate: lastModifiedDate });
    },
    changeDefaultAddress: function (isB2B, newDefaultRequestData, oldDefaultRequestData) {
        if (isB2B) {
            return b2bAddressesApi
                .editAddress(newDefaultRequestData)
                .then(function (_a) {
                var data = _a.data;
                var newDefaultAdr = data.addresses.address.find(function (adr) { return adr.isDefault; });
                if (!newDefaultAdr) {
                    throw new Error('Default address not set');
                }
                return newDefaultAdr;
            });
        }
        return b2cAddressesApi
            .editAddress(newDefaultRequestData, oldDefaultRequestData)
            .then(function (_a) {
            var data = _a.data;
            var newDefaultAdr = data.addresses.address.find(function (adr) { return adr.isDefault; });
            if (!newDefaultAdr) {
                throw new Error('Default address not set');
            }
            return newDefaultAdr;
        });
    },
    getPostalList: function (code) {
        return apiBase.get("".concat(ZIP_CODE_PATH, "/").concat(code)).then(function (_a) {
            var _b;
            var data = _a.data;
            if (data && ((_b = data.postalDetailsList) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                return data.postalDetailsList;
            }
            throw new Error('postalDetailsList is empty');
        });
    },
    addNewAddress: function (isB2B, requestData) {
        if (isB2B) {
            return b2bAddressesApi.addNewAddress(requestData);
        }
        return b2cAddressesApi.addNewAddress(requestData);
    },
    editAddress: function (isB2B, requestData) {
        if (isB2B) {
            return b2bAddressesApi.editAddress(requestData);
        }
        return b2cAddressesApi.editAddress(requestData);
    },
};
